<template>
  <v-dialog
      v-model="dialog"
      scroll-strategy="none"
      persistent
  >
    <v-card rounded="lg">
      <v-card-text class="fw-700 fs-24">
        {{ translation(translationList.account_already_exists, 'Cont existent detectat') }}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text class="pb-0">
        {{
          translation(translationList.account_already_exists_helper, 'Un cont cu această adresă de email există deja. Te rugăm să te autentifici pentru a continua cu contul tău.')
        }}
      </v-card-text>
        <authentication-container
            :fill-email="email"
            @close-dialog="handleCloseDialog"
            :default-version="false"
        >
        </authentication-container>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import {defineComponent, watch, ref, onMounted} from 'vue';
import {translation, useTranslationStore} from "~/plugins/store/translations";
import AuthLoginContainer from "~/components/auth/AuthLoginContainer.vue";
import type {TranslationList} from "~/types/Utils";
import AuthenticationContainer from "~/components/auth/AuthenticationContainer.vue";

export default defineComponent({
  components: {AuthenticationContainer, AuthLoginContainer},
  props: {
    userAlreadyExistsWithEmail: {
      type: Boolean,
      required: true,
    },
    email: {
      type: String as () => string | null,
      required: false,
    },
  },
  setup(props, {emit}) {
    const dialog = ref(false);
    const translationStore = useTranslationStore();
    const translationList = ref<TranslationList>({});

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
    });

    watch(() => props.userAlreadyExistsWithEmail, (newValue) => {
      if (newValue) {
        dialog.value = true;
      }
    });

    const handleCloseDialog = () => {
      dialog.value = false;
      emit('loggedIn');
    };

    return {
      dialog,
      translationList,
      translation,
      handleCloseDialog
    };
  },
});
</script>

<style scoped>
</style>
